import { render, staticRenderFns } from "./BailiffModal.vue?vue&type=template&id=8f1c1346&scoped=true&"
import script from "./BailiffModal.vue?vue&type=script&lang=js&"
export * from "./BailiffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c1346",
  null
  
)

export default component.exports